import AOS from 'aos';
import { jarallax, jarallaxVideo } from 'jarallax';
import '@fancyapps/fancybox';

$(document).ready(function () {
    // On Scroll animations
    AOS.init({
        once: true,
        offset: 100,
        duration: 600
        //,disable: 'mobile'
    });
    // Fix for cache issue
    $(window).on('load', function () {
        AOS.refresh();
        //AOS.refreshHard();
    });


    // Mobile menu
    $('.js-toggle-nav').click(function (e) {
        e.preventDefault();
        $('body').toggleClass('is-offCanvas');
    });
    $('.c-nav__item.has-dropdown').on('click', function (e) {
        if (e.target !== e.currentTarget) {
            return;
        }
        let h = 0;
        $('>ul>*', this).each(function () {
            h += $(this).outerHeight(true);
        });
        $(this).css('--height', h + 'px').toggleClass('open');
    });




    (function () {
        var parallax = $('.js-parallax');
        if (!parallax.length) return;
        jarallax(parallax, {
            speed: 0.7
        });
    })();

    (function () {
        var parallax = $('.js-parallax-alt');
        if (!parallax.length) return;
        jarallax(parallax, {
            disableParallax: /iPad|iPhone|iPod|Android/,
            speed: 0.9
        });
    })();

    $('video#hero').each(function () {
        const $video = $(this);
        $('<source/>').attr({
            src: $(this).data((768 >= $(window).width() ? 'mobile' : 'desktop') + '-src'),
            type: 'video/mp4',
        }).appendTo($video);
    });


    const gallery = [];
    $('body.projects .blocks-gallery-item > figure')
        .each(function () {
            $(this).data('idx', gallery.length);
            gallery.push({
                src: $('a', this).attr('href'),
                opts: {
                    thumb: $('img', this).attr('src'),
                    caption: $('figcaption', this).html()
                }
            });


        }).find('>*').on('click', function (e) {
            e.preventDefault();
            $.fancybox.open(gallery, {}, $(this).closest('figure').data('idx') );
        });
});